import { render, staticRenderFns } from "./HostingPending.vue?vue&type=template&id=1c12832b&"
import script from "./HostingPending.vue?vue&type=script&lang=js&"
export * from "./HostingPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c12832b')) {
      api.createRecord('1c12832b', component.options)
    } else {
      api.reload('1c12832b', component.options)
    }
    module.hot.accept("./HostingPending.vue?vue&type=template&id=1c12832b&", function () {
      api.rerender('1c12832b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/HostingPending.vue"
export default component.exports